import React, { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';

import { ProductType } from 'types/ProductListing/ProductListing';

import styles from './ProductList.module.scss';

export type PropsType = {
  products: ProductType[];
  renderProduct: (
    product: ProductType,
    className?: string,
    imageRatio?: string
  ) => JSX.Element;
} & HTMLAttributes<HTMLDivElement>;

const ProductList = forwardRef<HTMLDivElement, PropsType>(function ProductList(
  { products, renderProduct, children, className },
  ref
) {
  return (
    <div className={classNames(styles.container, className)} ref={ref}>
      {products.map(product => renderProduct(product))}
      {children}
    </div>
  );
});

export default ProductList;
